import { Component } from '@angular/core';
import { LandingSections } from '../../../../../domain/landing-config.interface';
import { LandingDesignBase } from '../landing-design-base';

// Diseño 3 de landing: barra con el logo centrado, hero con la imagen de fondo (título + instrucciones)
// y cards redondeadas (una columna por card, hasta 4).
@Component({
  selector: 'app-landing-design-3',
  templateUrl: './landing-design-3.component.html',
  styleUrls: ['./landing-design-3.component.scss'],
})
export class LandingDesign3Component extends LandingDesignBase {
  // Una columna por card, hasta 4 (1 card -> 1 columna, 3 -> 3, 4 o más -> 4)
  columns(section: LandingSections): number {
    return Math.min(Math.max(section.forms?.length || 1, 1), 4);
  }
}
